import script from "./ModuleTitleBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleTitleBar.vue?vue&type=script&setup=true&lang=js"

import "./ModuleTitleBar.vue?vue&type=style&index=0&id=aad694fe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_postcss@8.5.29_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aad694fe"]])

export default __exports__